module.exports = __webpack_public_path__ + "images/guide-front.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide-front.png
// module id = 432
// module chunks = 17